<div class="p-5">
    <div class="flex gap-5 flex-wrap place-content-end">
        <div class="w-[250px]"><std-input type="date" customLabel="label-input" customInputClass="custom-input"
                labelPosition="top" [placeholder]="'Seleziona data'" [label]="'Da'"
                [(ngModel)]="calendarStart" (change)="checkGetReport()"></std-input></div>
                <div class="w-[250px]"><std-input type="date" customLabel="label-input" customInputClass="custom-input"
                labelPosition="top" [placeholder]="'Seleziona data'" [label]="'A'"
                [(ngModel)]="calendarEnd" (change)="checkGetReport()"></std-input></div>
        <div class="w-[250px]"><std-select direction="down" (onChangeValue)="changeSelect($event,'selectedStore')" class="max-w-[400px]" typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Punto vendità"
      bindValue="id" bindLabel="name" customClassContaier="border-primary custom-select mb-5"
      placeholder="Seleziona punto vendità" [data]="stores"></std-select></div>
        <div class="w-[250px]"><std-select direction="down" (onChangeValue)="changeSelect($event,'selectedEmployee')" class="max-w-[400px]" typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Dipendente" bindValue="id"
      bindLabel="completeName" customClassContaier="border-primary custom-select mb-5"
      placeholder="Seleziona dipendente" [data]="employees"></std-select></div>
    </div>
    @if(!showTable){
    <div class="text-[32px] font-semibold text-primary">Seleziona i filtri per vedere il resoconto del dipendente</div>
    }
    @if(showTable && timeSheet[0]){
        <div class="text-[32px] font-semibold text-primary mb-2">Resoconto {{timeSheet[0].employee.firstName}} {{timeSheet[0].employee.lastName}}</div>
        <div class="text-[32px] font-semibold text-primary mb-2">Totale ore: {{totalHours}}</div>
    <std-table [data]="timeSheet">
        <span stdoutTableColumn width="calc(100% - 28px)" label="LAVORO">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end gap-5">
                {{item.job.name}}
            </div>
          </ng-template>
        </span>
        <span stdoutTableColumn width="calc(100% - 28px)" label="GIORNO">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end gap-5">
                {{item.day}}
            </div>
          </ng-template>
        </span>
        <span stdoutTableColumn width="calc(100% - 28px)" label="ORARIO">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end gap-5">
                {{item.startTime.slice(0,5)}}/{{item.endTime.slice(0,5)}}
            </div>
          </ng-template>
        </span>
    </std-table>
    }
</div>